<template>
    <div>
        <a-tabs v-model="searchP.processtype" @change="handleSubmit">
            <a-tab-pane key="oms" tab="订单系统">
            </a-tab-pane>
            <a-tab-pane key="dcms" tab="商品系统">
            </a-tab-pane>
            <a-tab-pane key="stms" tab="进销存系统">
            </a-tab-pane>
            <a-tab-pane key="salems" tab="促销系统">
            </a-tab-pane>
            <a-tab-pane key="acts" tab="广告系统">
            </a-tab-pane>
            <a-tab-pane key="wxms" tab="微信系统">
            </a-tab-pane>
            <a-tab-pane key="urms" tab="用户系统">
            </a-tab-pane>
            <a-tab-pane key="pays" tab="支付系统">
            </a-tab-pane>
            <a-tab-pane key="mbms" tab="会员系统">
            </a-tab-pane>
            <a-tab-pane key="zlscms" tab="中仑商城">
            </a-tab-pane>
        </a-tabs>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">

            <a-form-item label="版本">
                <a-select v-model="searchP.version" placeholder="" style="width: 80px" @change="handleSubmit">
                    <a-select-option value="V3.0"> 3.0 </a-select-option>
                    <a-select-option value="V5.0"> 5.0 </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item label="报文名称">
                <a-input v-model="searchP.servicename" placeholder="报文名称"></a-input>
            </a-form-item>

            <a-form-item label="报文关键字">
                <a-input v-model="searchP.keyword" placeholder="报文关键字"></a-input>
            </a-form-item>

            <a-form-item label="创建时间">
                <a-date-picker width="100px" v-decorator="[
                            'starttime',
                            {
                                initialValue: searchP.starttime || '',
                            }
                        ]" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" />
            </a-form-item>
            <a-form-item label="至">
                <a-date-picker v-decorator="[
                            'endtime',
                            {
                                initialValue: searchP.endtime || '',
                            }
                        ]" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" />
            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                processtype:'oms',
                version:'3.0',
                servicename:'',
                keyword:'',
                starttime:'',
                endtime:''
            }
        }
    },
    methods:{
        handleSubmit(){
            console.log(this.searchP);
            
            this.$emit("handleSearch",this.searchP);
        },
      
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

